import { render, staticRenderFns } from "./slotTable.vue?vue&type=template&id=a1c2675c"
import script from "./slotTable.vue?vue&type=script&lang=js"
export * from "./slotTable.vue?vue&type=script&lang=js"
import style0 from "./slotTable.vue?vue&type=style&index=0&id=a1c2675c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports